import { useMutation } from '@tanstack/react-query';

import { profileTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { Departments } from '@/types';

export const addProfile: profileTypes.AddProfile = (data) => {
  return axios.post(`/profile`, data);
};

type AddProfileOptions = {
  department: Departments;
  onSuccess: () => void;
  config?: MutationConfig<typeof addProfile>;
};

export function useAddProfile({ config = {}, onSuccess, department }: AddProfileOptions) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['profiles', department]);
      onSuccess();
    },
    ...config,
    mutationFn: addProfile,
  });
}
